import { combineReducers } from 'redux'
import advisorTypesReducer from './advisorTypesReducer'
import clientTypesReducer from './clientTypeReducer'
import pricingReducer from './pricingReducer'

export default combineReducers(
    {
        advisorTypes: advisorTypesReducer,
        clientTypes: clientTypesReducer,
        pricing: pricingReducer,
    }
)